jQuery(function ($) {
  $(".fv-special__close").on("click", () => {
    $(".fv-special").fadeOut();
  });
});
